/* import __COLOCATED_TEMPLATE__ from './account-name.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();